/**
 * Tracks the chat session currently open in this tab's UI (sidebar selection, etc.).
 * Used to suppress agent-response toasts when the user is already viewing that session.
 */

let activeSessionId: string | null = null

export function getActiveChatSessionId(): string | null {
  return activeSessionId
}

export function setActiveChatSessionId(sessionId: string | null): void {
  activeSessionId = sessionId
}
